export const COUNTRY_MESSAGES = {
  NOT_FOUND: 'No country records were found',
};


// WEBPACK FOOTER //
// ./src/constants/countryMessages.js